// extracted by mini-css-extract-plugin
export default {"container":"style_container__t7S8j","title":"style_title__mcLlN","divider":"style_divider__f6iFv","children":"style_children__Ezy1U","formFooter":"style_formFooter__+O5kF"};